import { render, staticRenderFns } from "./ManagePayroll.vue?vue&type=template&id=25308668&scoped=true"
import script from "./ManagePayroll.vue?vue&type=script&lang=ts"
export * from "./ManagePayroll.vue?vue&type=script&lang=ts"
import style0 from "./ManagePayroll.vue?vue&type=style&index=0&id=25308668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25308668",
  null
  
)

export default component.exports